import { DivProps } from '../../../../../../typings';
import { Plus } from 'lucide-react';
import UDButton from 'ud-ui/components/button';
import UDHeaderTitle from 'ud-ui/components/header-title';
import classNames from 'classnames';
import { theme } from 'styles/theme/theme';

interface IProps extends DivProps {
  title: string;
  createButtonText?: string;
  createButtonOnClick?: () => void;
}

function HeaderContentCategory(props: IProps) {
  const { title, createButtonText, createButtonOnClick, className, ...rest } = props;

  return (
    <div className={classNames('d-flex align-items-center', className)} {...rest}>
      <UDHeaderTitle>{title}</UDHeaderTitle>
      <div className="d-flex justify-content-end">
        {createButtonText && createButtonOnClick && (
          <UDButton className="d-flex align-items-center ml-6" variant="primary" onClick={createButtonOnClick}>
            <Plus size={16} className="mr-2" color={theme.colors.DarkBlue} />
            <span>{createButtonText}</span>
          </UDButton>
        )}
      </div>
    </div>
  );
}

export default HeaderContentCategory;
